<form
  class="acesso__form"
  novalidate
  [formGroup]="acessoForm"
  (submit)="acessar()"
  autocomplete="on"
>
  <header class="form__header">
    <button
      [ngClass]="{
        hide:
          bloquearPopupEtapaCadastro == true &&
          etapaLogin == ETAPA__COMPLETARCADASTRO
      }"
      style="border: none; background: transparent"
      type="button"
      [disabled]="realizandoLogin"
      class="header__voltar__acesso"
      (click)="voltarEtapa()"
      *ngIf="etapaLogin !== ETAPA__LOGIN"
    >
      <svg
        class="voltar__icone"
        width="12"
        height="20"
        viewBox="0 0 12 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M10 2L2 10L10 18"
          stroke="white"
          stroke-width="3"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
      Voltar
    </button>
    <img
      src="assets/images/logos/cacaulovers.png"
      class="lovers__image"
      [ngClass]="{ 'ajuste--esquerda': etapaLogin !== ETAPA__LOGIN }"
    />
    <p id="bemVindo" *ngIf="etapaLogin === ETAPA__LOGIN" class="bem__vindo">
      Bem-vindo, vamos entrar
    </p>
    <p *ngIf="etapaLogin === ETAPA__LOGIN" class="email__cpf">
      Informe seu e-mail ou CPF para iniciar o seu<br />
      cadastro ou entrar na sua conta.
    </p>
  </header>

  <main class="login__container">
    <div class="form__erro__login" *ngIf="mensagemLogin !== ''">
      <p
        class="erro__login__mensagem"
        [innerHTML]="mensagemLogin | boldColor"
      ></p>
    </div>
    <div class="etapa__login" *ngIf="etapaLogin === ETAPA__LOGIN">
      <div class="lovers-input__container container__cpf" *ngIf="!podeLogar">
        <input
          type="text"
          class="lovers-input"
          placeholder=" "
          formControlName="email"
          autocomplete="email"
          inputmode="email"
          id="cpf"
          (change)="setEmailCpf($event)"
        />
        <label for="" class="lovers-label">E-mail ou CPF</label>
      </div>
      <small
        *ngIf="msgInvalida"
        class="text-danger lovers-font--bold"
        [innerHTML]="msgInvalida"
      >
      </small>
      <button
        id="continuar"
        class="lovers-button"
        *ngIf="!podeLogar"
        [disabled]="!acessoForm.valid || entrando"
        [ngClass]="{
          'lovers--disabled': !acessoForm.valid || entrando,
          slideInDown: idStatus != 8 && podeLogar
        }"
      >
        {{ idStatus != 8 && podeLogar ? "Entrar" : "Continuar" }}
        <i *ngIf="entrando" class="fa fa-spinner fa-spin"></i>
      </button>
    </div>
    <div class="etapa__login" *ngIf="etapaLogin === ETAPA__SENHA">
      <p
        class="entrando__como"
        *ngIf="idStatus != 8 && podeLogar && !naoPossuiSenha"
      >
        Entrando como
        {{
          acessoForm.controls["email"].value.includes("@")
            ? acessoForm.controls["email"].value
            : retornaCpfFormatado()
        }}
      </p>
      <p
        id="senhaNaoCadastrada"
        class="entrando__como"
        *ngIf="idStatus != 8 && podeLogar && naoPossuiSenha"
      >
        Sua senha não está cadastrada, faça seu acesso por um código de
        validação:
      </p>
      <div
        class="lovers-input__container container__senha"
        *ngIf="idStatus != 8 && podeLogar && !naoPossuiSenha"
      >
        <input
          id="senha"
          [type]="tipoCampoSenha ? 'text' : 'password'"
          class="lovers-input"
          placeholder=" "
          formControlName="senha"
        />
        <label for="" class="lovers-label">Senha</label>
        <div class="text-right">
          <img
            class="opcao__icone mr-3 icone_visibilidade_senha"
            style="top: -36px"
            [src]="iconeSenha"
            (click)="trocarTipoCampoSenha(CAMPO_SENHA, iconeSenha)"
          />
        </div>
      </div>
      <p
        id="esqueciSenha"
        class="form__esqueci"
        (click)="irParaEsqueciSenha()"
        *ngIf="idStatus != 8 && podeLogar && !naoPossuiSenha"
      >
        Esqueci minha senha
      </p>
      <button
        id="entrar"
        class="lovers-button"
        *ngIf="podeLogar && !naoPossuiSenha"
        type="submit"
        [disabled]="!acessoForm.valid || entrando"
        [ngClass]="{
          'lovers--disabled': !acessoForm.valid || entrando
        }"
      >
        {{ idStatus != 8 && podeLogar ? "Entrar" : "Continuar" }}
        <i *ngIf="entrando" class="fa fa-spinner fa-spin"></i>
      </button>
      <div class="divisoria" *ngIf="!naoPossuiSenha">
        <p>entre sem senha</p>
      </div>
      <button
        id="continuarCelular"
        class="buttonMetodoLoginCelular"
        type="button"
        (click)="metodoLogin('celular')"
      >
        <img
          *ngIf="!realizandoEnvioCelular"
          src="assets/images/icons/mobileLogin.svg"
          alt="Ícone de celular"
        />
        <i *ngIf="realizandoEnvioCelular" class="fa fa-spinner fa-spin"></i>
        {{ realizandoEnvioCelular ? "Enviando..." : "Continuar com celular" }}
      </button>
      <button
        id="continuarEmail"
        class="buttonMetodoLoginEmail"
        type="button"
        (click)="metodoLogin('email')"
      >
        <img
          *ngIf="!realizandoEnvioEmail"
          src="assets/images/icons/mailLogin.svg"
          alt="Ícone de e-mail"
        />
        <i *ngIf="realizandoEnvioEmail" class="fa fa-spinner fa-spin"></i>
        {{ realizandoEnvioEmail ? "Enviando..." : "Continuar com e-mail" }}
      </button>
    </div>
    <div class="etapa__login" *ngIf="etapaLogin === ETAPA__PINCODE">
      <p class="cod__verificacao__titulo">Código de verificação</p>
      <div class="local__cod__verificacao">
        <p>Digite o código que enviamos para</p>
        <p>{{ paraEnviarCodigo }}</p>
      </div>
      <ng-otp-input
        [config]="otpInputConfig"
        (onInputChange)="validarCodigo($event)"
      >
      </ng-otp-input>
      <div class="loading__login" *ngIf="realizandoLogin">
        <i class="fa fa-spinner fa-spin"></i>
        <p>Entrando...</p>
      </div>
      <p
        class="codigo__invalido"
        *ngIf="habilitaCodigoInvalido && !realizandoLogin"
      >
        Código inválido
      </p>
      <p class="reenviar" *ngIf="!habilitaReenvio && !realizandoLogin">
        Reenviar código em {{ counter }} segundos
      </p>
      <button
        type="button"
        (click)="reenviarCodigo()"
        class="button__reenviar"
        *ngIf="habilitaReenvio && !realizandoLogin"
      >
        Reenviar código
      </button>
    </div>
    <div
      class="etapa__login"
      style="
        display: inline-flex;
        flex-direction: column;
        align-items: flex-start;
        gap: 32px;
      "
      *ngIf="etapaLogin === ETAPA__COMPLETARCADASTRO"
    >
      <div>
        <p class="etapa__cadastro_completo_dados_p">
          Confirme seus dados e tenha acesso a todos os benefícios Lovers!
        </p>
        <div style="display: flex; flex-direction: column; gap: 12px">
          <div class="lovers-input__container container__cpf">
            <input
              type="text"
              class="lovers-input"
              placeholder=""
              formControlName="nomeAceite"
              id="nomeAceite"
            />
            <label for="" class="lovers-label">Nome completo</label>
          </div>
          <div class="lovers-input__container container__cpf">
            <input
              type="text"
              mask="00/00/0000"
              class="lovers-input"
              placeholder=""
              formControlName="nascimentoAceite"
              id="nascimentoAceite"
            />
            <label for="" class="lovers-label">Data de nascimento</label>
          </div>
        </div>
      </div>
      <div class="lovers-checkbox__container">
        <input
          type="checkbox"
          name="termos"
          id="termos"
          formControlName="aceiteTermos"
        />
        <label class="" for="termos">
          Li e aceito os
          <span (click)="mostrarPopupTermos()">termos</span> e
          <span (click)="mostrarPopupRegulamento()">condições</span> do Programa
          Cacau Lovers
        </label>
      </div>
      <button
        (click)="atualizarStatus()"
        id="continuar"
        class="lovers-button"
        [ngClass]="{ 'lovers--disabled': !acessoForm.value.aceiteTermos }"
        [disabled]="!acessoForm.value.aceiteTermos || exibirLoader"
      >
        Entrar
        <i *ngIf="exibirLoader" class="fa fa-spinner fa-spin"></i>
      </button>
    </div>
  </main>
</form>

<lovers-popup
  [exibir]="exibePopupGenerico"
  (onClose)="exibePopupGenerico = false"
  tamanho="grande"
>
  <div class="popup__header">
    <p class="header__title">{{ tituloModalGenerico }}</p>
  </div>
  <div class="popup__body">
    <div class="descricao">
      <label class="mb-0">
        <span *ngFor="let item of descricaoModalGenerico" [innerHtml]="item">
        </span>
      </label>
    </div>
  </div>
</lovers-popup>
